import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { WithContext as ReactTagInput } from "react-tag-input";

import {
  FieldWrapper,
  Label,
  RequiredMark,
  ErrorText,
} from "./SharedFormStyles";

import { theme } from "../../../theme";

const FormTagInputField = ({
  name,
  label,
  control,
  error = null,
  required = false,
  placeholder = "",
  hint = "",
  disabled = false,
}) => {
  return (
    <FieldWrapper style={{ position: "relative" }}>
      {label && (
        <Label variant="body1" component="label" htmlFor={name}>
          {label} {required && <RequiredMark>*</RequiredMark>}{" "}
        </Label>
      )}

      {hint && (
        <p
          variant="body1"
          style={{
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <span style={{ color: theme.colors.amber, fontWeight: "bold" }}>
            Hint:
          </span>
          <span style={{ color: theme.colors.lightGray }}>({hint})</span>
        </p>
      )}

      <Controller
        name={name}
        control={control}
        disabled={disabled}
        render={({ field: { value, onChange } }) => {
          const handleTagAddition = (tag) => {
            onChange([...value, { ...tag, id: tag.text }]);
          };

          const handleTagDelete = (i) => {
            const updated = value.filter((_, index) => index !== i);
            onChange(updated);
          };

          return (
            <ReactTagInput
              tags={value || []}
              disabled={disabled}
              handleAddition={handleTagAddition}
              handleDelete={handleTagDelete}
              placeholder={placeholder}
              inputFieldPosition="top"
              autocomplete
              autofocus={false}
              classNames={{
                tag: "ReactTags__tag",
                remove: "ReactTags__remove",
                tagInput: "ReactTags__tagInput",
                tagInputField: "ReactTags__tagInputField",
              }}
            />
          );
        }}
      />

      {error && <ErrorText variant="body2">{error.message}</ErrorText>}

      {disabled && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "transparent",
            top: "0",
            left: "0",
          }}
        ></div>
      )}
    </FieldWrapper>
  );
};

FormTagInputField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  control: PropTypes.object.isRequired,
  error: PropTypes.object,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  hint: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FormTagInputField;
